import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import { RadioChangeEvent } from 'antd/lib/radio'

import { Button, Dropdown, Radio } from '@pepper/ui'
import {
  DecodedQueryParamFilters,
  SetQueryParamFilters,
} from 'components/items/FilterParams'

import { SortOption, sortOptions } from '../schema'

import s from './Sort.module.css'

type Props = {
  queryParamFilters: DecodedQueryParamFilters
  setQueryParamFilters: SetQueryParamFilters
}

const LastUpdatedSort = ({
  queryParamFilters,
  setQueryParamFilters,
}: Props) => {
  const { sort } = queryParamFilters
  const [sortValue, setSortValue] = useState<SortOption>(
    () =>
      sortOptions.find(item => item.sortBy === sort?.sort_by) ?? sortOptions[0]
  )

  const handleChange = (event: RadioChangeEvent) => {
    setSortValue(event.target.value)
  }

  useEffect(() => {
    if (sortValue) {
      if (
        sort?.sort_by !== sortValue?.sortBy ||
        sort?.sort_order !== sortValue.sortOrder
      ) {
        setQueryParamFilters(
          {
            ...queryParamFilters,
            currentPage: 0,
            sort: {
              sort_by: sortValue.sortBy,
              sort_order: sortValue.sortOrder,
            },
          },
          // prevents adding new history entry on initial load
          'replace'
        )
      }
    } else {
      sort &&
        setQueryParamFilters({
          ...queryParamFilters,
          sort: undefined,
        })
    }
  }, [sortValue])

  const menu = (
    <div className={s.wrapper}>
      <div className={s.title}>Sort By</div>
      {sortOptions.map(option => (
        <Radio
          key={option.label}
          value={option}
          checked={sortValue.label === option.label}
          onChange={handleChange}
        >
          {option.label}
        </Radio>
      ))}
    </div>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <Button className={s.btn}>
        <Icon icon="uil:sort-amount-up" width={18} height={18} />
        {sortValue.label}
      </Button>
    </Dropdown>
  )
}

export default LastUpdatedSort
